import {register} from 'register-service-worker';
import Swal from 'sweetalert2';

const registryEvent = new CustomEvent('regEvent', {detail: 'registered'});
const appVersionEvent = new CustomEvent('appVerEvent', {detail: 'v4.0.5.20'});
const appDbRegEvent = new CustomEvent('appDbEvent', {dbName: 'safepp-db', dbVersion: '1'});

const updatedEvent = new CustomEvent('updateEvent', {detail: 'updated'});
const updateEvent = new CustomEvent('updateEvent', {detail: 'update downloading'});
const connectionOfflineEvent = new CustomEvent('connEvent', {detail: 'offline'});
const connectionOnlineEvent = new CustomEvent('connEvent', {detail: 'online'});


if (process.env.NODE_ENV === 'production') {

    const cacheName = 'safepp-cache';

    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            document.dispatchEvent(connectionOnlineEvent);
        },
        registered() {

            document.dispatchEvent(registryEvent);
            document.dispatchEvent(appVersionEvent);
            document.dispatchEvent(appDbRegEvent);

            caches.open(cacheName)
                .then(function (cache) {
                    return cache.addAll([
                        '/favicon.ico',
                        '/index.html',
                        '/manifest.json',
                        '/robots.txt'
                    ]).catch(function (error) {
                        console.warn('SAFE cache warm-up skipped:', error);
                    });
                })

            self.addEventListener('fetch', function (event) {
                event.respondWith(
                    caches.open(cacheName)
                        .then(function (cache) {
                            cache.match(event.request)
                                .then(function (cacheResponse) {
                                    if (cacheResponse)
                                        return cacheResponse
                                    else
                                        return fetch(event.request)
                                            .then(function (networkResponse) {
                                                cache.put(event.request, networkResponse.clone())
                                                return networkResponse
                                            })
                                })
                        })
                )
            });


        },
        cached() {
        },
        updatefound() {
            document.dispatchEvent(updateEvent);
        },
        updated() {
            document.dispatchEvent(updatedEvent);
        },
        offline() {
            document.dispatchEvent(connectionOfflineEvent);
        },
        error(error) {
            Swal.fire({
                title: 'Error during service worker registration',
                text: error,
                icon: 'Error',
            });
        }
    });

    window.addEventListener('offline', () => {
        document.dispatchEvent(connectionOfflineEvent);
    });

    window.addEventListener('online', () => {
        document.dispatchEvent(connectionOnlineEvent);
    });
}
